import React from "react";
import { Link } from "react-router-dom";

function Breadcrumb({ title, middle = "" }) {
  return (
    <section className="custom-breadcrumb">
      <div className="container">
        <div className="custom-breadcrumb-inner">
          {/* Page Title - Minimal & Bold */}
          <h1 className="custom-breadcrumb-title">{title}</h1>

          {/* Path Navigation */}
          <nav className="custom-breadcrumb-path">
            <Link to="/" className="path-link">Home</Link>

            {middle && (
              <>
                <span className="path-divider">/</span>
                <Link to={`/${middle.toLowerCase()}`} className="path-link">
                  {middle}
                </Link>
              </>
            )}

            <span className="path-divider">/</span>
            <span className="active-path">{title}</span>
          </nav>
        </div>
      </div>
    </section>
  );
}

export default Breadcrumb;